import { Link, Typography } from '#atoms/index';

const Helper = ({ title, description }) => {
  return (
    <div className="helper">
      <div className="info">
        <Typography variant="h4">{title}</Typography>
        <Typography variant="body">{description}</Typography>
      </div>

      <div className="actions">
        <Link variant="outline-w-icon" href="/dashboard/contactar-a-soporte">
          Ir a contáctanos
        </Link>
      </div>
    </div>
  );
};

export default Helper;
